import React,{useState} from "react";
import { Card } from "antd";
import "./styles.css";
import { REFUSED } from "dns";
import {Link} from "react-router-dom"
const { Meta } = Card;

interface cat {
    category : {name:string, img:string}
}


const Categories: React.FC<cat>= ({category}) => {


  return (
    <Link to="/Shop">
      <Card  className="category" cover={<img src={category.img}  alt="example" />}>
      <Meta
        title={category.name}
        description="Ver mas"
      />
    </Card>
    </Link>

  );
};

export default Categories;
